import React, { useState } from "react";
import { transformToHtml, getCrId } from "../../../utils/CommonUtils";
import { FLIGHT_SEARCH_TYPE_OPTIONS } from "../constants";
import SearchTypeDropdown from "./SearchTypeDropdown";
import DateField from "./DateField";
import FlightNumberField from "./FlightNumberField";

const BY_FLIGHT_ONLY_OPTIONS = [
  {
    type: FLIGHT_SEARCH_TYPE_OPTIONS.BY_FLIGHT,
    text: "By Flight Number",
    fields: {
      AIRLINE: { label: "Flight Number", placeHolder: "e.g. 6E 123" },
      DATE: { label: "Date", placeHolder: "Select date" },
    },
    fieldsOrder: ["AIRLINE", "DATE"],
  },
];

const BY_FLIGHT_FIELDS = {
  AIRLINE: { label: "Flight Number", placeHolder: "e.g. 6E 123" },
  DATE: { label: "Date", placeHolder: "Select date" },
};
const DEFAULT_CTA = { text: "Check Status" };
const DEFAULT_META = { maxSelectablePastDays: 7, maxSelectableFutureDays: 30 };

export default function FlightStatusHeader({
  meta = DEFAULT_META,
  cta = DEFAULT_CTA,
  onSearch,
  formData: controlledFormData,
  setFormData: controlledSetFormData,
}) {
  const [internalFormData, setInternalFormData] = useState({
    AIRLINE: "",
    DATE: new Date().toISOString().slice(0, 10),
  });

  const formData = controlledFormData ?? internalFormData;
  const setFormData = controlledSetFormData ?? setInternalFormData;

  const [showDatepicker, setShowDatepicker] = useState(false);

  const handleFlightNumberChange = (e) => {
    setFormData({ ...formData, AIRLINE: e.target.value.toUpperCase() });
  };

  const handleDatepickerOpen = () => {
    setShowDatepicker((prev) => !prev);
  };

  const handleDateChange = (date, modifiers) => {
    if (modifiers?.disabled) return;
    if (date) {
      setFormData({ ...formData, DATE: date.toISOString().slice(0, 10) });
    }
    setShowDatepicker(false);
  };

  const isOutsideAllowedRange = (day) => {
    try {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const daysAgo = new Date(today);
      daysAgo.setDate(today.getDate() - (meta?.maxSelectablePastDays ?? 7));
      const daysFromNow = new Date(today);
      daysFromNow.setDate(today.getDate() + (meta?.maxSelectableFutureDays ?? 30));
      return day < daysAgo || day > daysFromNow;
    } catch {
      return false;
    }
  };

  const enableSearch = () => {
    return !!(formData.AIRLINE?.trim() && formData.DATE);
  };

  const redirectToFlightStatusDetail = () => {    
    const airlineParam = (formData.AIRLINE || "").replace(/\s+/g, "");
    const dateParam = formData.DATE || new Date().toISOString().slice(0, 10);
    const params = new URLSearchParams({      
      airline: airlineParam,
      date: dateParam,
      selectedOption: "byFlight",
      crId: getCrId(),
    });
    const detailUrl = `https://www.makemytrip.com/flight/flight-status/detail?${params.toString()}`;
    if (typeof window !== "undefined") {
      window.location.href = detailUrl;
    }
  };

  const handleSearch = () => {
    if (onSearch) onSearch(true);
    else redirectToFlightStatusDetail();
  };

  return (
    <div className="fs-header">
      <div className="fs-header__row">
        <SearchTypeDropdown
          options={BY_FLIGHT_ONLY_OPTIONS}
          selectedOption={FLIGHT_SEARCH_TYPE_OPTIONS.BY_FLIGHT}
          isOpen={false}
          onToggle={() => {}}
          onSelect={() => {}}
          readOnly
        />
        <div className="fs-header__fields">
          <FlightNumberField
            value={formData.AIRLINE || ""}
            fieldConfig={BY_FLIGHT_FIELDS.AIRLINE}
            onChange={handleFlightNumberChange}
          />
          <DateField
            value={formData.DATE || ""}
            placeholder={BY_FLIGHT_FIELDS.DATE.placeHolder}
            fieldConfig={BY_FLIGHT_FIELDS.DATE}
            isOpen={showDatepicker}
            onOpen={handleDatepickerOpen}
            onClose={() => setShowDatepicker(false)}
            onChange={handleDateChange}
            isOutsideAllowedRange={isOutsideAllowedRange}
          />
        </div>
        {cta && (
          <div className="fs-header__search-btn">
            <button
              type="button"
              className="button buttonPrimary"
              onClick={handleSearch}
              disabled={!enableSearch()}
            >
              {transformToHtml(cta.text)}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
